import { Controller } from '@hotwired/stimulus';
import Cropper from 'cropperjs/dist/cropper.esm';
import { debounce } from 'stimulus-library';

export default class extends Controller {
  static targets = [
    'image',
    'x',
    'y',
    'width',
    'height',
    'rotate',
    'scaleX',
    'scaleY',
    'preview',
  ];

  static defaultConfig = {
    zoomable: true,
    viewMode: 2,
    aspectRatio: 1,
    dragMode: 'move',
  };

  static values = {
    config: {
      type: Object,
      default: this.defaultConfig,
    },
  };

  get defaultConfig() {
    return {
      ...this.constructor.defaultConfig,
    };
  }

  initialize() {
    this.cropChanged = this.cropChanged.bind(this);
    this.updatePreviews = debounce(this.updatePreviews.bind(this), 500);
  }

  disconnect() {
    if (this.cropper) {
      this.cropper.destroy();
    }
  }

  setAspectRatio(event) {
    event.preventDefault();
    const { aspectRatio } = event.params;
    this.cropper.setAspectRatio(aspectRatio);
  }

  configValueChanged() {
    if (this.cropper) {
      this.cropper.destroy();
    }

    this.cropper = new Cropper(
      this.imageTarget,
      {
        ...this.defaultConfig,
        ...this.configValue,
        crop: (event) => this.cropChanged(event),
        zoom: (event) => this.cropChanged(event),
        cropmove: (event) => this.cropChanged(event),
      },
    );
  }

  cropChanged(event) {
    const {
      scaleY, scaleX, width, rotate, height, y, x,
    } = event.detail;
    if (this.hasXTarget) {
      this.xTarget.value = x;
    }
    if (this.hasYTarget) {
      this.yTarget.value = y;
    }
    if (this.hasWidthTarget) {
      this.widthTarget.value = width;
    }
    if (this.hasHeightTarget) {
      this.heightTarget.value = height;
    }
    if (this.hasRotateTarget) {
      this.rotateTarget.value = rotate;
    }
    if (this.hasScaleXTarget) {
      this.scaleXTarget.value = scaleX;
    }
    if (this.hasScaleYTarget) {
      this.scaleYTarget.value = scaleY;
    }
    this.updatePreviews();
  }

  updatePreviews() {
    const canvasContent = this.cropper.getCroppedCanvas().toDataURL();
    this.previewTargets.forEach((previewImage) => previewImage.src = canvasContent);
  }
}
